import { render, staticRenderFns } from "./RegulatoryUpdateAddressDocument.vue?vue&type=template&id=3dc0958a&scoped=true"
import script from "./RegulatoryUpdateAddressDocument.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateAddressDocument.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateAddressDocument.vue?vue&type=style&index=0&id=3dc0958a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc0958a",
  null
  
)

export default component.exports